
import React, { useEffect, useState } from "react";
import CommonSelect from "./CommonSelect";
import { Option } from "../gca-license-registration-form/index";
import * as Yup from "yup";
import { getSSODetailsByLogin, submitGcaBasicDetails } from "../../auth/services/privateapicalling";
import { useDispatch, useSelector } from "react-redux";
import { setApplicationId, setUserDet } from "../../../core/data/redux/authSlice";
import { Link } from "react-router-dom";
import CommonSelectTwo from "./commonselectTow";
import { toast } from "react-toastify";

interface BasicDetailsProps {
  districtOptions:Option[];
  talukaOptionsCurr:Option[];
  talukaOptionsReg:Option[];
  talukaOptionsPer:Option[];
  talukaOptions:Option[];
  apmcOptions: Option[];
  handleDistTaluka:(e: React.ChangeEvent<HTMLSelectElement>) => void;
  selectData: { district: string; taluka: string };
  setSelectData: React.Dispatch<React.SetStateAction<{ district: string; taluka: string , addressToUpdate:string}>>;
  onNext: (data: any) => void;
  onPrev: () => void;
  fetchApplicationIfExist: () => Promise<void>;
  isBasicDetailFilled:boolean;
  paymentStatus:string | null;
     fetchAllDistrictTaluka: (
      token: string,
      district?: string,
      taluka?: string,
      toUpdateDistOpt?: string
    ) => Promise<Option[]>;
    setTalukaOptions: React.Dispatch<React.SetStateAction<Option[]>>;
      setApmcOptions: React.Dispatch<React.SetStateAction<Option[]>>;
  isAllowed:boolean;
  existData:any;
  applicationId:string | null;
  setApplicationID: (applicationId: string) => void;
}



const BasicDetails: React.FC<BasicDetailsProps> = ({
  districtOptions,
  talukaOptionsCurr,
  talukaOptionsReg,
  talukaOptionsPer,
  talukaOptions,
  apmcOptions,
  handleDistTaluka,
  fetchAllDistrictTaluka,
  setApmcOptions,
  setTalukaOptions,
  selectData,
  setSelectData,
  onNext,
  onPrev,
  isBasicDetailFilled,
  paymentStatus,
  existData,applicationId,setApplicationID

}) => {

  const token = useSelector((state: any) => state.auth.token);
  const language = useSelector((state:any)=>state.auth.language);
  const formLanguage = useSelector((state: any) => state.auth.formLanguage)
  const [populateData, setPopulateData] = useState(null)
  

    const userdetails = useSelector((state: any) => state.auth.userDetails);
  const dispatch = useDispatch();


  const documents = [
    'Solvency Certificate',
    'Bank Balance Certificate',
    'Bank Guarantee',
    'Copies of IT Returns (for the last three years)',
    'Pan Card',
    'Copy of Election Card',
    'Proof of place of business',
    'Affidavit stating the probable place of business and the details of the Market Committee where the applicant is proposing to contest the election to the Market Committee.',
    'Declaration',
    'Agent Signature',
    'Partnership Deed (In case of a Partnership Firm)',
    'Article of Association of Company (In case of Company , Firm , Cooperative Society , LLP)',
    'Power of Attorney of Authorized Person (In case of Company)',
    'Copy of Registration Certificate,  Bye-Laws, Resolution for obtaining License, Last Audit Report, Income- Expenditure statement and Balance Sheet for the last three years (Cooperative Society)'
  ];


  const [formData, setFormData] = useState({
  // Track if user has interacted with the checkbox
  // ...existing code...
    districtId: existData && "department" in existData ? existData.department?.district_id : "",
    talukaId: existData && "department" in existData ? existData.department?.Taluka : "",
    departmentId: existData && "department" in existData ? existData.department?.id : "",
    applicantName: existData && "applicantName" in existData ? existData.applicantName : "",
    entityType: existData && "entityType" in existData ? existData?.entityType : "",
    validityUpTo: existData && "licenseType" in existData ? existData?.licenseType : "",
    currAt: existData && "currAddress" in existData ? existData?.currAddress[0]?.at : "",
    currTaluka: existData && "currAddress" in existData ? existData?.currAddress[0]?.taluka : "",
    currTalukaId: existData && "currAddress" in existData ? existData?.currAddress[0]?.talukaId : "",
    currDistrict: existData && "currAddress" in existData ? existData?.currAddress[0]?.district : "",
    currDistrictId: existData && "currAddress" in existData ? existData?.currAddress[0]?.districtId : "",
    perAt: existData && "perAddress" in existData ? existData?.perAddress[0]?.at : "",
    perTaluka:  existData && "perAddress" in existData ? existData?.perAddress[0]?.taluka : "",
    perTalukaId:  existData && "perAddress" in existData ? existData?.perAddress[0]?.talukaId : "",

    perDistrict:  existData && "perAddress" in existData ? existData?.perAddress[0]?.district : "",
    perDistrictId:  existData && "perAddress" in existData ? existData?.perAddress[0]?.districtId : "",
    regAt:  existData && "regOffAddress" in existData ? existData?.regOffAddress[0]?.at : "",
    regTaluka: existData && "regOffAddress" in existData ? existData?.regOffAddress[0]?.taluka : "",
    regTalukaId: existData && "regOffAddress" in existData ? existData?.regOffAddress[0]?.talukaId : "",

    regDistrict: existData && "regOffAddress" in existData ? existData?.regOffAddress[0]?.district : "",
    regDistrictId: existData && "regOffAddress" in existData ? existData?.regOffAddress[0]?.districtId : "",

    panCardNo: existData && "panCardNo" in existData ? existData?.panCardNo : "",
    electionCardNo: existData && "electionCardNo" in existData ? existData?.electionCardNo : "",
    regEmailId: existData && "regEmailId" in existData && (existData.regEmailId != "" && existData.regEmailId != null && existData.regEmailId != undefined)? existData.regEmailId : userdetails.EMAIL,
    mobileNo: existData && "mobileNo" in existData && (existData.mobileNo != "" && existData.mobileNo != null && existData.mobileNo != undefined) ? existData.mobileNo : userdetails.MOBILE,
  
        
  });

  useEffect(() => {
    if (populateData) {
      setFormData(prev => ({
        ...prev,
        // Only populate if the field is empty (no existData)
        applicantName: prev.applicantName || populateData?.FullName || "",
        currDistrict: prev.currDistrict || populateData?.CurrentDistrictName || "",
        currTaluka: prev.currTaluka || populateData?.CurrentTalukaName || "",
        currAt: prev.currAt || populateData?.CurrentHouseNameNo || "",
        perDistrict: prev.perDistrict || populateData?.PermanentDistrictName || "",
        perTaluka: prev.perTaluka || populateData?.PermanentTalukaName || "",
        perAt: prev.perAt || populateData?.PermanentHouseNoName || "",
      }));
    }
  }, [populateData]);
  
  // Keep the fetchSSODetails useEffect
  useEffect(() => {
    fetchSSODetails()
  }, []) 

  const [partners, setPartners] = useState<any[]>([]);
  const [partnerData, setPartnerData] = useState({ partnerName: "", partnerAge: "", partnerAddress: "" });
  const [addressCheckboxChecked, setAddressCheckboxChecked] = useState<boolean>(false);
  
  
  const [isLoading, setIsLoading] = useState(false);
 
  //.log('exist data from basic det form', formData,existData && "mobileNo" in existData )

  const [errors, setErrors] = useState<any>({});

  const [isValid, setIsValid] = useState(false);
const accountTypes = [
  { value: "Savings", label: "Savings" },
  { value: "Current", label: "Current" },
  { value: "Fixed Deposit", label: "Fixed Deposit" },]
  // Bank details array state
   const [bankDetails, setBankDetails] = useState(
  existData && "bankDetails" in existData && Array.isArray(existData.bankDetails) && existData.bankDetails.length > 0
    ? existData.bankDetails.map((detail: any) => ({

        bankAccountNo: detail.acct_no || "",
        IFSC: detail.ifsc_code || "",
        accountType: detail.acct_type || "",
        bankName: detail.bank_name || "",
        branchName: detail.branch_name || ""
      }))
    : [
        {
          bankAccountNo: "",
          IFSC: "",
          accountType: "",
          bankName: "",
          branchName: ""
        }
      ]
);
 
  // Validation for a single field
  function validateBankField(index: number, field: string, value: string) {
    let error = "";
    if (field === "bankAccountNo") {
      if (!value) error = "Bank Account No is required";
      else if (!/^\d{9,18}$/.test(value)) error = "Account No must be 9-18 digits";
    }
    if (field === "IFSC") {
      if (!value) error = "IFSC is required";
      else if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(value)) error = "Invalid IFSC format";
    }
    if (field === "accountType") {
      if (!value) error = "Account Type is required";
    }
    if (field === "bankName") {
      if (!value) error = "Bank Name is required";
    }
    if (field === "branchName") {
      if (!value) error = "Branch Name is required";
    }
    const updatedErrors = [...bankErrors];
    updatedErrors[index][field] = error;
    setBankErrors(updatedErrors);
  }

  // Validate all fields in a bank entry
  function validateBankEntry(index: number) {
    const entry = bankDetails[index];
    let valid = true;
    const errors: any = {};
    if (!entry.bankAccountNo) {
      errors.bankAccountNo = "Bank Account No is required";
      valid = false;
    } else if (!/^\d{9,18}$/.test(entry.bankAccountNo)) {
      errors.bankAccountNo = "Account No must be 9-18 digits";
      valid = false;
    }
    if (!entry.IFSC) {
      errors.IFSC = "IFSC is required";
      valid = false;
    } else if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(entry.IFSC)) {
      errors.IFSC = "Invalid IFSC format";
      valid = false;
    }
    if (!entry.accountType) {
      errors.accountType = "Account Type is required";
      valid = false;
    }
    if (!entry.bankName) {
      errors.bankName = "Bank Name is required";
      valid = false;
    }
    if (!entry.branchName) {
      errors.branchName = "Branch Name is required";
      valid = false;
    }
    const updatedErrors = [...bankErrors];
    updatedErrors[index] = errors;
    setBankErrors(updatedErrors);
    return valid;
  }

    // Bank details errors array state
    const [bankErrors, setBankErrors] = useState([
      {
        bankAccountNo: "",
        IFSC: "",
        accountType: "",
        bankName: "",
        branchName: ""
      }
    ]);
  
    // Handle change for bank details
    const handleBankDetailChange = (index: number, field: string, value: string) => {
      const updated = [...bankDetails];
      updated[index][field] = value;
      setBankDetails(updated);

      // Validate field on change
      validateBankField(index, field, value);
    };
  
    // Handle select change for accountType
    const handleBankSelectChange = (index: number, field: string, option: any) => {
      const updated = [...bankDetails];
      updated[index][field] = option ? option.value : "";
      setBankDetails(updated);
      validateBankField(index, field, option ? option.value : "");
    };
  
    // Add new bank detail
    const addBankDetail = () => {
      // Validate last entry before adding new
      const lastIdx = bankDetails.length - 1;
      const valid = validateBankEntry(lastIdx);
      if (!valid) return;
    
      setBankDetails([...bankDetails, {
        bankAccountNo: "",
        IFSC: "",
        accountType: "",
        bankName: "",
        branchName: ""
      }]);
    
     
          
      setBankErrors([...bankErrors, {
        bankAccountNo: "",
        IFSC: "",
        accountType: "",
        bankName: "",
        branchName: ""
      }]);
    };
  
    // Remove bank detail
    const removeBankDetail = (index: number) => {
      setBankDetails(bankDetails.filter((_, i) => i !== index));
      setBankErrors(bankErrors.filter((_, i) => i !== index));

    // Validation for a single field
   
    };
  

  const EntityOptions = [
    { value: "Ind", label: "Individual" },
    { value: "Firm", label: "Firm" },
    { value: "Company", label: "Company" },
    { value: "CoSciety", label: "Cooperative Society" },
    { value: "Fpo", label: "Farmer Producer Organization (FPO)" },
    { value: "govEnt", label: "Government Entity" },
    { value: "Ngo", label: "Non-Governmental Organization (NGO)" },
    { value: "partnerFirm", label: "Partnership Firm" },
    { value: "Llp", label: "Limited Liability Partnership (LLP)" },
    { value: "Trust", label: "Trust" },
    { value: "Jv", label: "Joint Venture" },
  ];

  const validationSchema = Yup.object().shape({
    applicantName: Yup.string()
    .matches(/^[A-Za-z\s]+$/, "Only alphabets and spaces are allowed, no special characters")
    .max(40, "Trader Name must not exceed 40 characters including spaces")
    .required("Trader Name is required"),
    entityType: Yup.string().required("Applicant Type is required"),
  bankDetails: Yup.array()
  .of(
    Yup.object().shape({
      bankAccountNo: Yup.string().required('Bank Account No is required'),
     IFSC: Yup.string()
  .required('IFSC is required')
  .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, 'Invalid IFSC format'),
      accountType: Yup.string().required('Account Type is required'),
      bankName: Yup.string().required('Bank Name is required'),
      branchName: Yup.string().required('Branch Name is required'),
    })
  )
  .test(
    'at-least-one-complete',
    'At least one complete bank detail is required',
    value => Array.isArray(value) && value.some(
      v =>
        v.bankAccountNo &&
        v.IFSC &&
        v.accountType &&
        v.bankName &&
        v.branchName
    )
  )
  .required('Bank details are required'),
    partners: Yup.array().when('entityType', {
      is: 'partnerFirm',
      then: (schema) =>
        schema
          .min(1, 'At least one partner is required for Partnership Firm')
          .of(
            Yup.object().shape({
              partnerName: Yup.string().required("Partner name is required"),
              // add other validations for partner fields if needed
            })
          ),
      otherwise: (schema) => schema.notRequired(),
    }),
    // departmentId: Yup.string().required("APMC selection is required"),
    departmentId: Yup.string().required("APMC selection is required"),
    validityUpTo: Yup.string().required("License Type is required"),
    currAt:  Yup.string().matches(/^[A-Za-z0-9\s+\/'",.\-_@#$%&*()!?:;]+$/,
      "Only alphabets, spaces,numbers and the following special characters are allowed: + / ' , ."
    )
    .max(80, "Current Address must not exceed 80 characters including spaces")
    .required("Current Address (At) is required"),
    currTaluka: Yup.string().matches(/^[A-Za-z0-9\s+\/'",.\-_@#$%&*()!?:;]+$/, "Only alphabets and spaces are allowed, no special characters")
    .max(40, "Current Address (Taluka)  must not exceed 40 characters including spaces")
    .required("Current Address (Taluka) is required"),
    currDistrict: Yup.string().matches(/^[A-Za-z0-9\s+\/'",.\-_@#$%&*()!?:;]+$/, "Only alphabets and spaces are allowed, no special characters")
    .max(40, "Current Address (District)  must not exceed 40 characters including spaces")
    .required(
      "Current Address (District) is required"
    ),


    perAt: Yup.string().matches(/^[A-Za-z0-9\s+\/'",.\-_@#$%&*()!?:;]+$/,
      "Only alphabets, spaces,numbers and the following special characters are allowed: + / ' , ."
    )
    .max(80, "Permanent Address must not exceed 80 characters including spaces")
    .required("Permanent Address (At) is required"),
    perTaluka: Yup.string().matches(/^[A-Za-z0-9\s+\/'",.\-_@#$%&*()!?:;]+$/, "Only alphabets and spaces are allowed, no special characters")
    .max(40, "Permanent Address (Taluka)  must not exceed 40 characters including spaces").
    required("Permanent Address (Taluka) is required"),
    perDistrict: Yup.string()
    .matches(/^[A-Za-z0-9\s+\/'",.\-_@#$%&*()!?:;]+$/, "Only alphabets and spaces are allowed, no special characters")
    .max(40, "Permanent Address (District)  must not exceed 40 characters including spaces").
    required( "Permanent Address (District) is required"),

    regAt: Yup.string().matches(/^[A-Za-z0-9\s+\/'",.\-_@#$%&*()!?:;]+$/,
      "Only alphabets, spaces,numbers and the following special characters are allowed: + / ' , ."
    )
    .max(80, "Registered Office Address must not exceed 80 characters including spaces")
    .required("Registered Office Address (At) is required"),
    regTaluka: Yup.string().matches(/^[A-Za-z0-9\s+\/'",.\-_@#$%&*()!?:;]+$/, "Only alphabets and spaces are allowed, no special characters")
    .max(40, "Registered Office Address (Taluka)  must not exceed 40 characters including spaces")
    .required(
      "Registered Office Address (Taluka) is required"
    ),
    regDistrict: Yup.string().matches(/^[A-Za-z0-9\s+\/'",.\-_@#$%&*()!?:;]+$/, "Only alphabets and spaces are allowed, no special characters")
    .max(40, "Registered Office Address (District)  must not exceed 40 characters including spaces")
    .required(
      "Registered Office Address (District) is required"
    ),

    panCardNo: Yup.string()
      .matches(
        /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
        "Invalid PAN Card Number (e.g., ABCDE1234F)"
      )
      .required("PAN Card Number is required"),

    electionCardNo: Yup.string()
      .matches(
        /^[A-Z]{3}[0-9]{7}$/,
        "Invalid Election Card Number (e.g., ABC1234567)"
      )
      .required("Election Card Number is required"),
  });

  const validateForm = () => {
    //.log(" form...");

    const requiredFields = ["applicantName", "departmentId", "validityUpTo","currAt","currTaluka","currDistrict"];
    const missingFields = requiredFields.filter(
      (field) => !formData[field as keyof typeof formData]
    );

    if (missingFields.length > 0) {
      // alert(`Please fill in the required fields: ${missingFields.join(", ")}`);
      toast.error(`Please fill in the required fields: ${missingFields.join(", ")}`, {position: "top-right", autoClose: 3000,});
      return false;
    }
    return true;
  };

  const traderLicenseOptions: Option[] = [
    { value: "1", label: "1 Year" },
    
  ];

  // Handle partner input changes
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setPartnerData({ ...partnerData, [name]: value });

    // Clear error when user starts typing
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const handlePanElection = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value.toUpperCase() });
    setErrors((prevErrors) => ({
      ...prevErrors,
      [e.target.name]: undefined,
    }));
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
   //.log("applicant name",e.target.value)

    setFormData({ ...formData, [e.target.name]: e.target.value });


    setErrors((prevErrors) => ({
      ...prevErrors,
      [e.target.name]: undefined,
    }));
  };

  const handleSelectChange = (name: string, option: Option | null) => {
 

    if(name == "entityType" && option.value!=="partnerFirm")
    {
    
      setPartners([]);
      setPartnerData({ partnerName: "", partnerAge: "", partnerAddress: "" });


    }
   
    setFormData({ ...formData, [name]: option ? option.value : "" });
  };
  
const handleDistrictTalukaChange = async (name: string, option: Option | null) => {

  if (name === "district") {
    const newDistrictId = option?.value || '';
  
    setFormData((prev) => ({
      ...prev,
      districtId: newDistrictId,  
      talukaId: '',               
      departmentId: ''           
    }));

    if (newDistrictId) {
      await fetchAllDistrictTaluka(token, newDistrictId, '', 'pob');
    } else {
      setTalukaOptions([]);
      setApmcOptions([]);
    }
  }

  else if (name === "taluka") {
    const newTalukaId = option?.value || '';
    const newTalukaValue = option?.label || '';
  
    setFormData((prev) => ({
      ...prev,
      talukaId: newTalukaId,
      departmentId: ''           
    }));

    if (formData.districtId && newTalukaValue) {
      await fetchAllDistrictTaluka(token, formData.districtId, newTalukaValue, 'pob');
    } else {
      setApmcOptions([]);
    }
  }

  else if (name === "department") {
    setFormData((prev) => ({
      ...prev,
      departmentId: option?.value || ''
    }));
  }
};

const handleAddress = async (name: string, option: Option | null, id?: string, toUpdate?: string) => {


  if (name === "currDistrict" || name === "perDistrict" || name === "regDistrict") {
    const newDistrictId = option?.value || '';
    const newDistrictValue = option?.label || '';

    const taluka = name === "currDistrict" ? "currTaluka" : name === "perDistrict" ? "perTaluka" : "regTaluka";
  

    // Update form data first
    setFormData((prev) => ({
      ...prev,
      [name]: newDistrictValue,
      [id]: newDistrictId,
      [taluka]: ""
    }));

    // Fetch talukas immediately with the new district
    if (newDistrictId) {
      await fetchAllDistrictTaluka(token, newDistrictId, '', toUpdate);
    }
  }
  else if (name === "currTaluka" || name === "perTaluka" || name === "regTaluka") {
    const newTalukaId = option?.value || '';
    const newTalukaValue = option?.label || '';

 

    setFormData((prev) => ({
      ...prev,
      [name]: newTalukaValue,
      [id]: newTalukaId
    }));

    // Fetch APMCs if needed
    const districtField = name === "currTaluka" ? "currDistrictId" : 
                         name === "perTaluka" ? "perDistrictId" : "regDistrictId";
    const districtId = formData[districtField];
    
    if (districtId && newTalukaValue) {
      await fetchAllDistrictTaluka(token, districtId, newTalukaValue, toUpdate);
    }
  }
};

  const validatePartnerForm = async () => {
    try {
      const partnerSchema = Yup.object().shape({
        partnerName: Yup.string().trim().matches(/^[A-Za-z\s]+$/, "Only alphabets are allowed").required("Name is required.").max(30),
        partnerAge: Yup.number()
  .typeError("Age must be a number.")
  .positive("Age must be a positive number.")
  .integer("Age must be an integer.")
  .max(120, "Age cannot exceed 120 years.") // Adjust max limit as needed
  .required("Age is required."),
        partnerAddress: Yup.string()
        .trim()
        .matches(/^[A-Za-z0-9\s+\/'",.\-_@#$%&*()!?:;]+$/, "Only alphabets, numbers, spaces, commas, periods, hyphens, and slashes are allowed.")
        .required("Address is required.")
        .max(50, "Address cannot exceed 50 characters"),
      });
  
      await partnerSchema.validate(partnerData, { abortEarly: false });
      setErrors({});
      return true;
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errorMessages = {};
        err.inner.forEach((error) => {
          if (error.path) {
            errorMessages[error.path] = error.message;
          }
        });
        setErrors(errorMessages);
      }
      return false;
    }
  };

  const addPartner = async() => {
    
    const isValid = await validatePartnerForm();
   
      if(isValid)
      {
        setPartners([...partners, partnerData]);

      }
    
      setPartnerData({ partnerName: "", partnerAge: "", partnerAddress: "" });

  };

  const deletePartner = (index: number) => {
    setPartners(partners.filter((_, i) => i !== index));
  };

  const validationForm = async () => {
    try {
      //.log("Validating form...");
      await validationSchema.validate({...formData,partners,bankDetails}, { abortEarly: false });
      setErrors({});
      return true;
    } catch (err: any) {
      const newErrors: Record<string, string> = {};
      err.inner.forEach((error: any) => {
        newErrors[error.path] = error.message;
      });

    
      setErrors(newErrors);
      return false;
    }
  };

  const handleSubmit = async () => {
    
    if(isBasicDetailFilled == true)
    {
           
      
      const isValid = await validationForm();

      if (!isValid) return;

      // setIsLoading(true)

      const formattedData = {
        departmentId: formData.departmentId,
        currDistrictId:formData.currDistrictId,
        currTalukaId:formData.currTalukaId,
        perDistrictId:formData.perDistrictId,
        perTalukaId:formData.perTalukaId,

        regDistrictId: formData.regDistrictId,
        regTalukaId:formData.regTalukaId,
        entityType: formData.entityType,
        partnerDetails: partners.length > 0 ? partners : existData?.partners || [],
        applicantName: formData.applicantName,
        validityUpTo: formData.validityUpTo,
     currAddress: [
          {  district: formData.currDistrict,
                taluka: formData.currTaluka,
            at: formData.currAt
        
          
          },
        ],

        perAddress: [
          {
              
            district: formData.perDistrict,
             taluka: formData.perTaluka,
            at: formData.perAt
         
          },
        ],
        regOffAddress: [
          {  district: formData.regDistrict,
             taluka: formData.regTaluka,
            at: formData.regAt,
           
          
          },
        ],
        panCardNo: formData.panCardNo,
        electionCardNo: formData.electionCardNo,
        regEmailId: formData.regEmailId,
        mobileNo: formData.mobileNo,
        bankDetails: bankDetails.map((detail) => ({
          acct_no: detail.bankAccountNo,
          ifsc_code: detail.IFSC,
          acct_type: detail.accountType,
          bank_name: detail.bankName,
          branch_name: detail.branchName
        }))
      };
      try {
        setIsLoading(true)
        const res = await submitGcaBasicDetails(
          {
            ...formattedData,
          },
          token,
          applicationId
        );
     
        if(res.success== true)
        {
          setApplicationID(res?.data?.applicationId)
          onNext(formData)
        }
       
      } catch (error) {
      
        if(error === "panCardNo")
        {
        // alert(`${error} already axists`);
        toast.error(`${error} already axists`, {position: "top-right", autoClose: 3000,});
        setIsLoading(false)
        
        }
        else{
          // alert(`something went wrong ${error}`)
          toast.error(`something went wrong ${error}`, {position: "top-right", autoClose: 3000,});
          setIsLoading(false)

        }
     
      } finally {
        setIsLoading(false)
      }
     
    }
    else{
           

      const isValid = await validationForm();
        
          
          if (!isValid) return;

          if (validateForm()) {
          

            const formattedData = {
              departmentId: formData.departmentId,
              currDistrictId:formData.currDistrictId,
              currTalukaId:formData.currTalukaId,
              perDistrictId:formData.perDistrictId,
              perTalukaId:formData.perTalukaId,

              regDistrictId: formData.regDistrictId,
              regTalukaId:formData.regTalukaId,
              entityType: formData.entityType,
               partnerDetails: partners.length > 0 ? partners : existData?.partners || [],
              applicantName: formData.applicantName,
              validityUpTo: formData.validityUpTo,
           currAddress: [
          {  district: formData.currDistrict,
                taluka: formData.currTaluka,
            at: formData.currAt
        
          
          },
        ],

        perAddress: [
          {
              
            district: formData.perDistrict,
             taluka: formData.perTaluka,
            at: formData.perAt
         
          },
        ],
        regOffAddress: [
          {  district: formData.regDistrict,
             taluka: formData.regTaluka,
            at: formData.regAt,
           
          
          },
        ],
              panCardNo: formData.panCardNo,
              electionCardNo: formData.electionCardNo,
              regEmailId: formData.regEmailId,
              mobileNo: formData.mobileNo,
              bankDetails: bankDetails.map((detail) => ({
                acct_no: detail.bankAccountNo,
                ifsc_code: detail.IFSC,
                acct_type: detail.accountType,
                bank_name: detail.bankName,
                branch_name: detail.branchName
              })),
            };

            //.log("Formatted Data:", formattedData);
            try {
              setIsLoading(true)
             const res = await submitGcaBasicDetails(formattedData, token, applicationId);
            

              //.log("Response:", res);
              //setApplicationID(res.data.applicationId)
              if (res.success === false) {
                // alert(`${res.message}`);
                toast.error(`${res.message}`, {position: "top-right", autoClose: 3000,});
                
              } else {
                const applicationId = res.data.applicationId;
                //.log('appp id from basic det response' ,applicationId)
                dispatch(setApplicationId(applicationId))
                onNext(formData);
              }
            } catch (error) {
              //.log("Error:", error);
            //  alert("Error submitting form data:");
             toast.error(`Error submitting form data:`, {position: "top-right", autoClose: 3000,});

            } finally{
              setIsLoading(false)
            }
          }
    }
   

  };

   useEffect(() => {
 
      if(existData && existData?.partnerDetails?.length>0)
      {
        setPartners(existData.partnerDetails)
        
      }
    },[]
    )

          const fetchSSODetails = async () =>{
            try{
              const res = await getSSODetailsByLogin(token);
              if (res.success && res.data){
                setPopulateData(res?.data)
              
              }
              else{
               
              }
            } catch (error){
             
              // alert("Failed to Load the Application Data")
              toast.error("Failed to Load the Application Data", {position: "top-right", autoClose: 3000,});
            }
          }

  return (
    <div className="container">
      <div className="card">
      <div className="p-4 border rounded-lg shadow-md bg-white mb-4">
      <h2 className="text-xl font-semibold mb-4 text-gray-800">
      Prepare these documents before starting to fill out this application.
      </h2>
      <ul className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-2 list-disc list-inside text-danger">
        {documents.map((doc, index) => (
          <li key={index}>{doc}</li>
        ))}
      </ul>
    </div>
        <div className="card-header">
          <h5 className="card-title">{language.enter_detail}</h5>
        </div>
       { paymentStatus=="SUCCESS" ?
       <div className="text-danger">You have Filled Your Application</div>
        :
       <div className="card-body">
          <div className="mb-3">
            <label className="form-label">
      એજન્ટનું નામ (Agent Name) <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className={`form-control ${
              errors.applicantName ? "is-invalid" : ""
              }`}
              name="applicantName"
              value={formData.applicantName}
              onChange={handleChange}
              required
            />
            {errors.applicantName && (
              <div className="invalid-feedback">{errors.applicantName}</div>
            )}
        
          </div>
          <div className="mb-3">
            <label className="form-label">
            {formLanguage.applicant_type} ({language.applicant_type})<span className="text-danger">*</span>
            </label>
            {/* <CommonSelect
              options={EntityOptions}
              value={EntityOptions.find(option => option.value === formData.entityType) || null}
                defaultValue={EntityOptions.find(option => option.value === (existData?.entityType || formData.entityType)) || undefined}
                onChange={(option) => handleSelectChange("entityType", option)}
              /> */}
              <CommonSelect
              options={EntityOptions}
              value={EntityOptions.find(option => option.value === formData.entityType) || null}
                defaultValue={EntityOptions.find(option => option.value === (formData.entityType)) || undefined}
                onChange={(option) => handleSelectChange("entityType", option)}
              />

            {errors.entityType && (
              <div className="invalid-feedback d-block">
                {errors.entityType}
              </div>
            )}
          </div>

           {formData.entityType !=="" && formData.entityType === "partnerFirm" && (
                      <>
                      
                        <Link to="#" className="btn btn-primary mb-3 btn-sm" data-bs-toggle="modal" data-bs-target="#traderpartnerModal">
                          + {language.add_partner}
                        </Link>
                        
                        {partners.length > 0 && (
                          <>
                          <h5>{formLanguage.partner_details} ({language.partner_details})</h5>

                          <table className="table table-bordered mb-4">
                            <thead>
                              <tr><th>Sr No.</th><th>{language.name}</th><th>{language.age}</th><th>{language.address}</th><th></th></tr>
                            </thead>
                            <tbody>
                            
                              { partners.map((partner, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{partner.partnerName}</td>
                                  <td>{partner.partnerAge}</td>
                                  <td>{partner.partnerAddress}</td>
                                  <td>
                                    <button className="btn btn-danger btn-sm" onClick={() => deletePartner(index)}>🗑 {language.delete}</button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>

                          </>
                        )}
                         
                      </>
                    )}
                     {errors.partners && (
              <div className="text-danger mb-4">{errors.partners}</div>
            )}
        

         <div className="mb-3">
            <h4>
            {formLanguage.placeOfBusiness}  ({language.placeOfBusiness} )<span className="text-danger">*</span>
            </h4>
            
            <label className="form-label mt-2">
              {formLanguage.district}({language.district})
            </label>
            <CommonSelectTwo
             options={[...districtOptions].sort((a, b) => a.label.localeCompare(b.label))}
              // value={districtOptions.find(option => option.value === selectData.district) || null}
              value={districtOptions.find(option => option.value === formData.districtId) || null}

              // defaultValue={districtOptions.find(option => option.value === (existData?.department?.id || formData.departmentId)) || undefined}
              onChange={(option) => handleDistrictTalukaChange("district", option )}
              placeholder="District"
            />

            <label className="form-label mt-2">
              {formLanguage.district}({language.taluka})
            </label>
            <CommonSelectTwo
           options={[...talukaOptions].sort((a, b) => a.label.localeCompare(b.label))}
              // value={talukaOptions.find(option => option.value === selectData.taluka ) || null}
              value={talukaOptions.find(option => option.value === formData.talukaId) || null}

              // defaultValue={districtOptions.find(option => option.value === (existData?.department?.id || formData.departmentId)) || undefined}
              onChange={(option) => handleDistrictTalukaChange("taluka", option)}
              placeholder="Taluka"
            />

            {/* {errors.departmentId && (
              <div className="invalid-feedback d-block">
                {errors.departmentId}
              </div>
            )} */}
          </div>

          <div className="mb-3">
            <label className="form-label">
            {formLanguage.register_with_apmc}  ({language.register_with_apmc} )<span className="text-danger">*</span>
            </label>
            <CommonSelectTwo
              options={[...apmcOptions].sort((a, b) => a.label.localeCompare(b.label))}
              value={apmcOptions.find(option => option.value === formData.departmentId) || null}
              // defaultValue={apmcOptions.find(option => option.value === (existData?.department?.id || formData.departmentId)) || undefined}
             
              onChange={(option) => handleSelectChange("departmentId", option)}
              placeholder="APMC"
            />
            {errors.departmentId && (
              <div className="invalid-feedback d-block">
                {errors.departmentId}
              </div>
            )}
          </div>
          

          <div className="mb-3">
            <label className="form-label">
            {formLanguage.license_type} ({language.license_type}) <span className="text-danger">*</span>
            </label>
            <CommonSelect
              options={traderLicenseOptions}
              // defaultValue={traderLicenseOptions.find(option => option.value === (existData?.licenseType || formData.validityUpTo)) || undefined}
              value={
                traderLicenseOptions.find(
                  (option) => option.value === formData.validityUpTo
                ) || null
              }
              defaultValue={traderLicenseOptions.find(option => option.value === (formData.validityUpTo)) || undefined}

              onChange={(option) => handleSelectChange("validityUpTo", option)}
            />

            {errors.validityUpTo && (
              <div className="invalid-feedback d-block">
                {errors.validityUpTo}
              </div>
            )}
          </div>

          {/* Address Fields */}
          
          <h5>{formLanguage.current_address} ({language.current_address}) <span className="text-danger">*</span></h5>

            {/* <input
            type="text"
            className={`form-control mb-3 ${
              errors.currDistrict ? "is-invalid" : ""
            }`}
            placeholder={language.district}
            name="currDistrict"
            value={formData.currDistrict}
            onChange={handleChange}
            />
            {errors.currDistrict && (
            <div className="invalid-feedback d-block">
              {errors.currDistrict}
            </div>
          )} */}

          <CommonSelectTwo
             options={[...districtOptions].sort((a, b) => a.label.localeCompare(b.label))}
              className="mb-3"
              // value={districtOptions.find(option => option.value === selectData.district) || null}
              // value={districtOptions.find(option => option.label === formData.currDistrict) || null}
              value={formData.currDistrict}

              // defaultValue={districtOptions.find(option => option.value === (existData?.department?.id || formData.departmentId)) || undefined}
              onChange={(option) => handleAddress("currDistrict", option , "currDistrictId" , "curr")}
              placeholder="District"
            />
             {errors.currDistrict && (
            <div className="invalid-feedback d-block">
              {errors.currDistrict}
            </div>
          )}

            {/* <input
            type="text"
            className={`form-control mb-3 ${
              errors.currTaluka ? "is-invalid" : ""
            }`}
            placeholder={language.taluka}
            name="currTaluka"
            value={formData.currTaluka}
            onChange={handleChange}
            /> */}

            <CommonSelectTwo
            options={[...talukaOptionsCurr].sort((a, b) => a.label.localeCompare(b.label))}
              className="mb-3"

              // value={districtOptions.find(option => option.value === selectData.district) || null}
              // value={talukaOptions.find(option => option.label === formData.currTaluka) || null}
              value={formData.currTaluka}


              // defaultValue={districtOptions.find(option => option.value === (existData?.department?.id || formData.departmentId)) || undefined}
              onChange={(option) => handleAddress("currTaluka", option , "currTalukaId","curr")}
              placeholder="Taluka"
            />

            {errors.currTaluka && (
            <div className="invalid-feedback d-block">{errors.currTaluka}</div>
            )}


           <input
            type="text"
            className={`form-control mb-3 ${errors.currAt ? "is-invalid" : ""}`}
            placeholder={language.address}
            name="currAt"
            value={formData.currAt}
            onChange={handleChange}
            />
            {errors.currAt && (
            <div className="invalid-feedback d-block">{errors.currAt}</div>
            )}


          {/* Checkbox to copy current address to permanent address */}
          <div className="form-check mb-2">
            <input
              className="form-check-input"
              type="checkbox"
              id="sameAsCurrentAddress"
              checked={addressCheckboxChecked && formData.perAt === formData.currAt && formData.perTaluka === formData.currTaluka && formData.perDistrict === formData.currDistrict}
              onChange={e => {
                setAddressCheckboxChecked(e.target.checked);
                if (e.target.checked) {
                  setFormData(prev => ({
                    ...prev,
                    perAt: prev.currAt,
                    perTaluka: prev.currTaluka,
                    perDistrict: prev.currDistrict,
                    perTalukaId: prev.currTalukaId,
                    perDistrictId: prev.currDistrictId
                  }));
                } else {
                  setFormData(prev => ({
                    ...prev,
                    perAt: "",
                    perTaluka: "",
                    perDistrict: "",
                    perTalukaId: "",
                    perDistrictId: ""
                  }));
                }
              }}
            />
            <label className="form-check-label" htmlFor="sameAsCurrentAddress">
              Same as Current Address
            </label>
          </div>
          <h5>{formLanguage.permanent_address}  ({language.permanent_address} ) <span className="text-danger">*</span></h5>

            {/* <input
            type="text"
            className={`form-control mb-3 ${
              errors.perDistrict ? "is-invalid" : ""
            }`}
            placeholder={language.district}
            name="perDistrict"
            value={formData.perDistrict}
            onChange={handleChange}
            /> */}
            <CommonSelectTwo
             options={[...districtOptions].sort((a, b) => a.label.localeCompare(b.label))}
              className="mb-3"
              // value={districtOptions.find(option => option.value === selectData.district) || null}
              // value={districtOptions.find(option => option.label === formData.perDistrict) || null}
              value={formData.perDistrict}


              // defaultValue={districtOptions.find(option => option.value === (existData?.department?.id || formData.departmentId)) || undefined}
              onChange={(option) => handleAddress("perDistrict", option , "perDistrictId","per")}
              placeholder="District"
            />
            {errors.perDistrict && (
            <div className="invalid-feedback d-block">{errors.perDistrict}</div>
          )}

         

            {/* <input
            type="text"
            className={`form-control mb-3 ${
              errors.perTaluka ? "is-invalid" : ""
            }`}
            placeholder={language.taluka}
            name="perTaluka"
            value={formData.perTaluka}
            onChange={handleChange}
            /> */}
            <CommonSelectTwo
             options={[...talukaOptionsPer].sort((a, b) => a.label.localeCompare(b.label))}
              className="mb-3"

              // value={districtOptions.find(option => option.value === selectData.district) || null}
              // value={talukaOptions.find(option => option.label === formData.perTaluka) || null}
              value={formData.perTaluka}


              // defaultValue={districtOptions.find(option => option.value === (existData?.department?.id || formData.departmentId)) || undefined}
              onChange={(option) => handleAddress("perTaluka", option , "perTalukaId","per")}
              placeholder="Taluka"
            />
            {errors.perTaluka && (
            <div className="invalid-feedback d-block">{errors.perTaluka}</div>
            )}

            <input
            type="text"
            className={`form-control mb-3 ${errors.perAt ? "is-invalid" : ""}`}
            placeholder={language.address}
            name="perAt"
            value={formData.perAt}
            onChange={handleChange}
            />
            {errors.perAt && (
            <div className="invalid-feedback d-block">{errors.perAt}</div>
            )}
          

          <h5>{formLanguage.registered_office_address} ({language.registered_office_address} ) <span className="text-danger">*</span></h5>

           {/* <input
            type="text"
            className={`form-control mb-3 ${
              errors.regDistrict ? "is-invalid" : ""
            }`}
            placeholder={language.district}
            name="regDistrict"
            value={formData.regDistrict}
            onChange={handleChange}
            /> */}
             <CommonSelectTwo
             options={[...districtOptions].sort((a, b) => a.label.localeCompare(b.label))}
              className="mb-3"
              // value={districtOptions.find(option => option.value === selectData.district) || null}
              // value={districtOptions.find(option => option.label === formData.regDistrict) || null}
              value={formData.regDistrict}


              // defaultValue={districtOptions.find(option => option.value === (existData?.department?.id || formData.departmentId)) || undefined}
              onChange={(option) => handleAddress("regDistrict", option ,"regDistrictId","reg")}
              placeholder="District"
            />
          
            {errors.regDistrict && (
            <div className="invalid-feedback d-block">{errors.regDistrict}</div>
          )}

            {/* <input
            type="text"
            className={`form-control mb-3 ${
              errors.regTaluka ? "is-invalid" : ""
            }`}
            placeholder={language.taluka}
            name="regTaluka"
            value={formData.regTaluka}
            onChange={handleChange}
            /> */}
            <CommonSelectTwo
             options={[...talukaOptionsReg].sort((a, b) => a.label.localeCompare(b.label))}
              className="mb-3"

              // value={districtOptions.find(option => option.value === selectData.district) || null}
              // value={talukaOptions.find(option => option.label === formData.regTaluka) || null}
              value={formData.regTaluka}


              // defaultValue={districtOptions.find(option => option.value === (existData?.department?.id || formData.departmentId)) || undefined}
              onChange={(option) => handleAddress("regTaluka", option , "regTalukaId","reg")}
              placeholder="Taluka"
            />
            {errors.regTaluka && (
            <div className="invalid-feedback d-block">{errors.regTaluka}</div>
            )}

            

           <input
            type="text"
            className={`form-control mb-3 ${errors.regAt ? "is-invalid" : ""}`}
            placeholder={language.address}
            name="regAt"
            value={formData.regAt}
            onChange={handleChange}
            />
            {errors.regAt && (
            <div className="invalid-feedback d-block">{errors.regAt}</div>
            )}

          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">
              {formLanguage.pan_card_no} ({language.pan_card_no}) <span className="text-danger">*</span>
              </label>
                <input
                type="text"
                className={`form-control ${
                  errors.panCardNo ? "is-invalid" : ""
                }`}
                name="panCardNo"
                value={formData.panCardNo}
                onChange={handlePanElection}
                />
              {errors.panCardNo && (
                <div className="invalid-feedback d-block">
                  {errors.panCardNo}
                </div>
              )}
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">
              {formLanguage.election_card_no} ({language.election_card_no}) <span className="text-danger">*</span>
              </label>
                <input
                type="text"
                className={`form-control ${
                  errors.electionCardNo ? "is-invalid" : ""
                }`}
                name="electionCardNo"
                value={formData.electionCardNo}
                onChange={handlePanElection}
                />
              {errors.electionCardNo && (
                <div className="invalid-feedback d-block">
                  {errors.electionCardNo}
                </div>
              )}
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">
              {formLanguage.email} ({language.email}) <span className="text-danger">*</span>
              </label>
                <input
                type="text"
                className={`form-control ${
                  errors.regEmailId ? "is-invalid" : ""
                }`}
                name="electionCardNo"
                value={userdetails.EMAIL}
                disabled={true}
                // onChange={handlePanElection}
                />
              {errors.regEmailId && (
                <div className="invalid-feedback d-block">
                  {errors.regEmailId}
                </div>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">
              {formLanguage.mobile} ({language.mobile}) <span className="text-danger">*</span>
              </label>
                <input
                type="text"
                className={`form-control ${
                  errors.mobileNo ? "is-invalid" : ""
                }`}
                name="mobileNo"
                value={userdetails.MOBILE}
                disabled={true}
                // onChange={handlePanElection}
                />
              {/* {errors.mobileNo && (
                <div className="invalid-feedback d-block">
                  {errors.mobileNo}
                </div>
              )} */}
            </div>
          </div>
           <h5>{formLanguage.bankDetails} ({language.bankDetails}) <span className="text-danger">*</span></h5>

          {/* Dynamic Bank Details Section */}
          {bankDetails.map((bank, idx) => (
            <div className="row" key={idx} style={{ borderBottom: "1px solid #eee", marginBottom: 10, paddingBottom: 10 }}>
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  {formLanguage.acct_no} ({language.acct_no}) <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="bankAccountNo"
                  value={bank.bankAccountNo}
                  onChange={e => handleBankDetailChange(idx, "bankAccountNo", e.target.value)}
                />
                {bankErrors[idx]?.bankAccountNo && (
                  <div className="text-danger">{bankErrors[idx].bankAccountNo}</div>
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  {formLanguage.ifsc_code} ({language.ifsc_code}) <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="IFSC"
                  value={bank.IFSC}
                  onChange={e => handleBankDetailChange(idx, "IFSC", e.target.value.toUpperCase())}
                />
                {bankErrors[idx]?.IFSC && (
                  <div className="text-danger">{bankErrors[idx].IFSC}</div>
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  {formLanguage.acct_type} ({language.acct_type}) <span className="text-danger">*</span>
                </label>
                <CommonSelect
                  options={accountTypes}
                  value={accountTypes.find(option => option.value === bank.accountType) || null}
                  onChange={option => handleBankSelectChange(idx, "accountType", option)}
                  defaultValue={accountTypes.find(option => option.value === (bank.accountType)) || undefined}
                />
                {bankErrors[idx]?.accountType && (
                  <div className="text-danger">{bankErrors[idx].accountType}</div>
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  {formLanguage.bank_name} ({language.bank_name}) <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="bankName"
                  value={bank.bankName}
                  onChange={e => handleBankDetailChange(idx, "bankName", e.target.value)}
                />
                {bankErrors[idx]?.bankName && (
                  <div className="text-danger">{bankErrors[idx].bankName}</div>
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  {formLanguage.branch_name} ({language.branch_name}) <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="branchName"
                  value={bank.branchName}
                  onChange={e => handleBankDetailChange(idx, "branchName", e.target.value)}
                />
                {bankErrors[idx]?.branchName && (
                  <div className="text-danger">{bankErrors[idx].branchName}</div>
                )}
              </div>
              <div className="col-md-6 mb-3 d-flex align-items-end">
                {bankDetails.length > 1 && (
                  <button type="button" className="btn btn-danger me-2" onClick={() => removeBankDetail(idx)}>
                    Remove
                  </button>
                )}
                {idx === bankDetails.length - 1 && (
                  <button type="button" className="btn btn-success" onClick={addBankDetail}>
                    Add More
                  </button>
                )}
              </div>
            </div>
          ))}
          {errors.bankDetails && (
            <div className="text-danger mb-4">{errors.bankDetails}</div>
          )}
          {/* Navigation Buttons */}
          <div className="d-flex justify-content-end mt-3">
            {/* <button
              type="button"
              className="btn btn-secondary me-4"
              onClick={onPrev}
            >
              {language.previous}
            </button> */}
         
            <button type="button" className="btn btn-primary"  onClick={handleSubmit} disabled={isLoading}>
              {isLoading ? (
                <i className="ion-load-a ion-spin"></i> // Loading spinner
              ) : (
                ` ${language.next}`
              )}
            </button>
          </div>

          <div className="modal fade" id="traderpartnerModal">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">{formLanguage.add_partner_details} ({language.add_partner_details})</h4>
              <button type="button" className="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
            <div className="modal-body pb-0">
        <div className="row">
          <div className="col-md-6">
            <div className="mb-3">
              <label className="form-label">
              {formLanguage.name} ({language.name} )<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                name="partnerName"
                value={partnerData.partnerName}
                onChange={handleInputChange}
                required
              />
              {errors.partnerName && <div className="text-danger">{errors.partnerName}</div>}
            </div>
          </div>
          <div className="col-md-6">
            <div className="mb-3">
              <label className="form-label">
              {formLanguage.age_in_year} ({language.age_in_year}) <span className="text-danger">*</span>
              </label>
              <input
                type="number"
                className="form-control"
                name="partnerAge"
                value={partnerData.partnerAge}
                onChange={handleInputChange}
                required
              />
              {errors.partnerAge && <div className="text-danger">{errors.partnerAge}</div>}
            </div>
          </div>
          <div className="col-md-12">
            <div className="mb-3">
              <label className="form-label">
              {formLanguage.address} ({language.address}) <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                name="partnerAddress"
                value={partnerData.partnerAddress}
                onChange={handleInputChange}
                required
              />
              {errors.partnerAddress && <div className="text-danger">{errors.partnerAddress}</div>}
            </div>
          </div>
        </div>
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-white border me-2" data-bs-dismiss="modal">
          {language.can}
        </button>
        <button type="button" className="btn btn-primary"   onClick={addPartner}   {...(isValid ? { "data-bs-dismiss" : "modal" } : {})} >
          {language.save_partner}
        </button>
      </div>
            </form>
          </div>
        </div>
      </div>

        </div>}
      </div>
            {isLoading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-25"
          style={{ zIndex: 9999 }}
        >
          <div className="d-flex align-items-center px-4 py-3 bg-white rounded shadow">
            <div
              className="spinner-border text-primary me-3"
              role="status"
            />
            <span className="fw-semibold text-dark">
              Submitting...
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default BasicDetails;
